import { PerspectiveCamera } from "@react-three/drei";
import { useFrame, useThree } from "@react-three/fiber";
import React, { useContext, useEffect, useRef } from "react";
import { AppContext } from "./App";
import angleBetweenPoints from "./utility_functions/AngleBetweenPoints";
import dist from "./utility_functions/Dist";

export default function CameraController() {
  const { playerRef, playerSpeed, cameraRef, startPosition } =
    useContext(AppContext);
  const cameraFollowing = useRef(false);
  const speed = useRef(0);
  const maxSpeed = Math.sqrt(0.3 * 0.3 + 0.3 * 0.3);
  const accSpeed = 0.02;
  const cameraMoveStartDist = 2.3;
  const cameraMoveStopDist = 1;
  const cameraHeight = 30;

  //useEffect(() => void setDefaultCamera(cameraRef.current), []);
  useEffect(() => {
    cameraRef.current.position.set(
      startPosition.x,
      cameraHeight,
      startPosition.z
    );
  }, []);

  useFrame(() => {
    const distanceToPlayer = dist(
      { x: cameraRef.current.position.x, y: cameraRef.current.position.z },
      { x: playerRef.current.position.x, y: playerRef.current.position.z }
    );
    if (distanceToPlayer > cameraMoveStartDist) {
      cameraFollowing.current = true;
      if (speed.current < maxSpeed) {
        speed.current += accSpeed;
        const playerTotalSpeed = Math.sqrt(
          Math.pow(playerSpeed.current.x, 2) +
            Math.pow(playerSpeed.current.z, 2)
        );
        if (speed.current > playerTotalSpeed) speed.current = playerTotalSpeed;
      }
    }
    if (distanceToPlayer < cameraMoveStopDist) {
      cameraFollowing.current = false;
      if (speed.current - accSpeed > 0) {
        speed.current -= accSpeed;
      } else {
        speed.current = 0;
      }
    }

    if (!cameraFollowing.current) {
    }
    const angle = angleBetweenPoints(
      { x: cameraRef.current.position.x, y: cameraRef.current.position.z },
      { x: playerRef.current.position.x, y: playerRef.current.position.z }
    );

    const dX = Math.cos(angle) * speed.current;
    const dZ = Math.sin(angle) * speed.current;

    cameraRef.current.position.set(
      cameraRef.current.position.x + dX,
      cameraRef.current.position.y,
      cameraRef.current.position.z + dZ
    );
  });

  return (
    //@ts-ignore
    <PerspectiveCamera
      ref={cameraRef}
      makeDefault
      near={0.1}
      far={1000}
      zoom={0.4}
      position={[0, cameraHeight, 0]}
      rotation={[-Math.PI / 2, 0, 0]}
    />
  );
}
